import IwocaIcon from '../svg/IwocaPayIconCompact.svg?react';

export function LoadingScreen() {
  return (
    <div className="fixed inset-0 z-[999] flex h-full w-full flex-col items-center justify-center bg-white">
      <IwocaIcon
        viewBox="0 0 55 35"
        width="200"
        height="100"
        title="iwocaPay icon"
      />
      <div className="flex items-end">
        <h1 className="m-0 text-[2rem] font-med text-coral-65">Loading</h1>
        <div className="mb-[0.45rem] ml-[20px] flex items-center gap-[7px]">
          <div className="h-[8px] w-[8px] animate-dot-flashing rounded-[5px] bg-coral-65 [animation-delay:0s]" />
          <div className="h-[8px] w-[8px] animate-dot-flashing rounded-[5px] bg-coral-65 [animation-delay:0.5s]" />
          <div className="h-[8px] w-[8px] animate-dot-flashing rounded-[5px] bg-coral-65 [animation-delay:1s]" />
        </div>
      </div>
    </div>
  );
}
